const toOptions = (terms: string[]) =>
  terms.map((term) => ({ label: term, value: term }));

const exchangeTerms = [
  "Na prontidão",
  "Antes do embarque",
  "No embarque",
  "Antes da chegada",
];

const nationalizationTerms = [
  "No desembaraço",
  "Antes do desembaraço",
  "Após o desembaraço",
  "Contra NF",
];

export const supplierExchangeTermOptions = toOptions([
  ...exchangeTerms,
  "Contra documentos",
]);

export const clientExchangeTermOptions = toOptions([
  ...exchangeTerms,
  "Contra NF",
]);

export const supplierNationalizationTermOptions = toOptions(nationalizationTerms);

export const clientNationalizationTermOptions = toOptions([
  ...nationalizationTerms,
  "À Prazo após NF",
]);

// POs antigas guardavam texto livre: mantém o valor salvo selecionável
export const withLegacyTerm = (
  options: { label: string; value: string }[],
  current?: string | null
) =>
  current && !options.some((o) => o.value === current)
    ? [...options, { label: current, value: current }]
    : options;

export const formatPaymentTerm = (term?: string | null, days?: number | null) =>
  [term, days == null ? null : `${days} dias`].filter(Boolean).join(" - ");
